// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yxJWb0{margin:0;padding:0;font-size:inherit;font-weight:inherit;overflow:hidden}.Yv4ppA{display:-webkit-box;-webkit-box-orient:vertical;white-space:normal}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `yxJWb0`,
	"lineClamp": `Yv4ppA`
};
export default ___CSS_LOADER_EXPORT___;
